var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative",
      "padding-top": "20px"
    },
    style: {
      "--color": _vm.styleObj.color
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticClass: "infoBox"
  }, [_c("top-title", {
    attrs: {
      themeColor: _vm.styleObj.color
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("被保险人信息")))])]), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index + 2,
      staticClass: "listBox"
    }, [_c("div", {
      staticClass: "list"
    }, _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2 + 1
      }, [_c("div", [_vm._v(_vm._s(_vm.$t(item2.name)))]), item2.isArrow ? _c("a-icon", {
        attrs: {
          type: "right"
        }
      }) : _vm._e()], 1);
    }), 0)]);
  })], 2), _c("div", {
    staticClass: "infoBox"
  }, [_c("top-title", {
    attrs: {
      themeColor: _vm.styleObj.color
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保方案")))])]), _c("div", {
    staticClass: "listBox2"
  }, _vm._l(_vm.list2, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "list"
    }, _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2,
        class: item2.isClick ? "hit" : ""
      }, [_vm._v(" " + _vm._s(_vm.$t(item2.name)) + " ")]);
    }), 0)]);
  }), 0)], 1), _c("div", {
    staticClass: "infoBox"
  }, [_c("top-title", {
    attrs: {
      themeColor: _vm.styleObj.color
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("添加附加险（可多选）")))])]), _c("div", {
    staticClass: "additional-show"
  }, [_c("div", {
    staticClass: "additional-show1"
  }, [_c("div", {
    staticClass: "production"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("产品名称")))]), _c("span", {
    staticClass: "right"
  }, [_vm._v("2" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) + _vm.$t("/人")))])]), _c("div", {
    staticStyle: {
      color: "#a0a0a0",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t("保障金额")) + "：" + _vm._s(_vm.$t("20万")))]), _c("span", {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.$t("必购")))])]), _c("div", {
    staticClass: "additional-show2"
  }, [_c("div", {
    staticClass: "production"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")))]), _c("span", {
    staticClass: "right"
  }, [_vm._v("2" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) + _vm.$t("/人")))])]), _c("div", [_c("span", {
    staticClass: "btn-money",
    style: "background-color:" + _vm.styleObj.color
  }, [_vm._v(_vm._s(_vm.$t("20万")))]), _c("span", {
    staticClass: "btn-money",
    staticStyle: {
      "background-color": "#ebebeb",
      color: "#000"
    }
  }, [_vm._v(_vm._s(_vm.$t("30万")))])]), _c("span", {
    staticClass: "icon"
  }, [_vm._v("✔️")])])])], 1), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };